;(function() {
  'use strict'

  Service.$inject = ["$q", "api", "subscriberService"];
  angular.module('app.core').service('projectSearchService', Service)

  var MIN_LENGTH = 2

  /* @ngInject */
  function Service($q, api, subscriberService) {
    var self = this
    var token = 0

    self.normalise = normalise
    self.isSearchable = isSearchable
    self.search = search
    self.cancel = cancel

    // Trim, then collapse internal runs of whitespace, so `coffee   cap` and
    // `coffee cap` are one query and produce one request between them.
    function normalise(query) {
      return (query || '').trim().replace(/\s+/g, ' ')
    }

    function isSearchable(query) {
      return normalise(query).length >= MIN_LENGTH
    }

    function search(query) {
      var normalised = normalise(query)
      var thisToken = ++token
      return $q(function(resolve, reject) {
        api.projects
          .search({
            query: normalised,
            includeArchived: true,
            ownerId: subscriberService.getSubscriber().id,
          })
          .then(function(data) {
            if (thisToken !== token) return
            resolve({ query: normalised, hitsById: indexById(data) })
          })
          .catch(function() {
            if (thisToken !== token) return
            reject()
          })
      })
    }

    // Moves the counter on, so a request already in flight is ignored when it lands.
    function cancel() {
      token++
    }

    // Keyed by project id so the page's filter is one lookup per project
    // rather than a scan of the response per project.
    function indexById(hits) {
      return _.keyBy(hits || [], 'projectId')
    }
  }
})()
